import TenantAPI from '@/apis/business/tenantAPI'
import CrudBase from '@/stores/crudBase.js'

const crudBase = new CrudBase('tenant', TenantAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
    tenantDetail: {},
    tenants: [],
  },
  mutations: {
    ...crudBase.mutations,

    setTenantDetail (state, params) {
      state.tenantDetail = params
    },

    setTenants (state, params) {
      state.tenants = params
    },
  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,

    async getTenantBySGDTenantCode (context, payload) {
      const res = await TenantAPI.getTenantBySGDTenantCode(payload)
      if (res) {
        context.commit('setTenantDetail', res)
      }
      return res
    },

    async getEnrollmentOnlineByTenantId (context, payload) {
      const res = await TenantAPI.getEnrollmentOnlineByTenantId(payload)
      if (res) {
        context.commit('setTenants', res)
      }
      return res
    },
  },
}
